module.exports = __webpack_public_path__ + "img/middle-50-housing.30aaf96a.jpg";